// Vendors
import React from 'react';

const LocatorFilter = ({ places, currentFilters, handleFilterChange }) => {
  if (!places.length) return null;
  const dealerTypes = [];
  places.map((place) => {
    const dealerType = place.dealerType.includes(', ')
      ? place.dealerType.split(', ')
      : place.dealerType.split();

    dealerType.map((type) => {
      if (!dealerTypes.includes(type)) dealerTypes.push(type);
    });
  });

  return (
    <div className="form__field">
      {dealerTypes.map((type, i) => (
        <label key={i} className="form__checkbox">
          <input
            type="checkbox"
            value={type}
            onChange={() => handleFilterChange(type)}
            checked={currentFilters.includes(type)}
          />
          {type}
        </label>
      ))}
    </div>
  );
};

export default LocatorFilter;
